<template>
    <div id="registor">
        <div class="container">
            <div class="login-box" align="center">
                <div class="main-text" align="center">
                    输入券码
                </div>
                
                <form>
                    <div class="form1">
                        <input class="user coupon-code" type="email" align="center" placeholder="请输入券码。" v-on:input="handleChangeCouponInput">
                        <p class="wrong-text" v-html='errorMessage'></p>
                    </div>

                    <div id="red-btn-popup">
                        <input class="red-btn" type="button" value="确认" v-on:click='handleRegisterClick'>
                    </div>
                </form>
                
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    mounted() {
        if (this.$route.query.couponcode != undefined) {
            var couponCode = this.$route.query.couponcode.replace(/\W/g,"")
            document.getElementsByClassName('coupon-code')[0].value = couponCode
        }

        this.handleChangeCouponInput()
    },
    data() {
        const text = require("../../text/parent/laptop.js").default;
        const l10n = text[this.$store.state.lang] ? text[this.$store.state.lang] : text['cn'];
        const lang = this.$store.state.lang;
	    return {
            l10:l10n,
            changedLanguage:lang,
            lang:lang,
            errorMessage: '',
        }
    },
    methods: {
        handleChangeCouponInput() {
            if (document.getElementsByClassName('coupon-code').length == 0) return
            
            this.errorMessage = ''
            this.toggleClass(document.getElementsByClassName('coupon-code')[0], 'error', 'remove')

            var btn = document.getElementsByClassName('red-btn')[0]
            var code = document.getElementsByClassName('coupon-code')[0].value.replace(/\W/g,"")
            document.getElementsByClassName('coupon-code')[0].value = code

            if (code == '') {
                this.toggleClass(btn, 'dimmed', 'add')
            } else {
                this.toggleClass(btn, 'dimmed', 'remove')
            }
        },

        async handleRegisterClick() {
            var couponCode = document.getElementsByClassName('coupon-code')[0].value.replace(/\W/g,"")
            if (couponCode == '') {
                this.errorMessage = this.l10["Coupon_not_input"]
                return
            }

            const res = await axios.post(
                "/english/v2/coupons/enterCode",
                {
                    accountId: this.$store.getters.getAccountId,
                    code: couponCode,
                    packageName: "com.enuma.todoyingyu"
                }
            )
            if (!res.data.result) {
                // this.$emit('message', this.l10["Coupon_Error_" + res.data.errorCode])
                this.errorMessage = this.l10["Coupon_Error_" + res.data.errorCode]
                this.toggleClass(document.getElementsByClassName('coupon-code')[0], 'error', 'add')
            } else {
                this.$emit('complete', couponCode)

            }
        },

         toggleClass(element, className, type) { 
            var check = new RegExp("(\\s|^)" + className + "(\\s|$)");
            if (check.test(element.className) && type == 'remove') { 
                element.className = element.className.replace(check, " ").trim();
            } else if (!check.test(element.className) && type == 'add') { 
                element.className += " " + className;
            } 
        }

    }
}
</script>
<style src="@/assets/coupon/register.css" scoped></style>
<style scoped>
@media (max-width: 720px) {
    input {-webkit-appearance: none;-moz-appearance: none;appearance: none;}
}
</style>